import { render } from "./PrivacyPolicyModal.vue?vue&type=template&id=b0e5f3b2&scoped=true&ts=true"
import script from "./PrivacyPolicyModal.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyModal.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyModal.vue?vue&type=style&index=0&id=b0e5f3b2&lang=scss&scoped=true"
import "./PrivacyPolicyModal.vue?vue&type=style&index=1&id=b0e5f3b2&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/end-vue_us_qa_azure_v24042026_02/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0e5f3b2"]])

export default __exports__